var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.validKey)?_c('div',[_c('iframe',{staticClass:"game-frame",attrs:{"src":_vm.data.link}})]):_c('div',[_c('p',[_vm._v("Invalid game id")])])}
var staticRenderFns = []

export { render, staticRenderFns }